import Cookies from 'js-cookie'

// App
const sidebarStatusKey = 'sidebar_status'
export const getSidebarStatus = () => Cookies.get(sidebarStatusKey)
export const setSidebarStatus = (sidebarStatus: string) => Cookies.set(sidebarStatusKey, sidebarStatus)

const languageKey = 'language'
export const getLanguage = () => Cookies.get(languageKey)
export const setLanguage = (language: string) => Cookies.set(languageKey, language)

const sizeKey = 'size'
export const getSize = () => Cookies.get(sizeKey)
export const setSize = (size: string) => Cookies.set(sizeKey, size)

// User
const userKey = 'user_data'
const tokenKey = 'vue_typescript_admin_access_token'
export const getUser = () => Cookies.get(userKey) ? JSON.parse(Cookies.get(userKey) as string) : {}
export const setUser = (user: string) => Cookies.set(userKey, user)
export const removeUser = () => Cookies.remove(userKey)
export const getToken = () => Cookies.get(tokenKey)
export const setToken = (token: string) => Cookies.set(tokenKey, token)
export const removeToken = () => Cookies.remove(tokenKey)

const processingAuthKey = 'processing_auth'
export const setProcessingAuth = (state: boolean) => Cookies.set(processingAuthKey, '' + state)
export const getProcessingAuth = () => Cookies.get(processingAuthKey) === 'true'
export const removeProcessingAuth = () => Cookies.remove(processingAuthKey)
